import { slideDown, slideUp, slideToggle, debounce } from "./helpers/plainSlide.js";

/**
 * Class for package tabs
 * This class is responsible for handling the package tabs loacated in frontpage after hero banner
 */

class PackageTabs {
  constructor() {
    this.tab = document.querySelector('[role="tablist"]');
    this.speed = 200;

    if (this.tab) {
      this.initTabs();
    }
  }

  /**
   * Initializes the package tabs
   */
  initTabs() {
    const that = this;
    const tabButtons = that.tab.querySelectorAll('[role="tab"]');

    if (tabButtons) {
      for (let i = 0; i < tabButtons.length; i++) {
        const tabWrapper = tabButtons[i].parentNode.parentNode;
        const tabOpener = tabWrapper.querySelector('.js-reveal-packages');

        // When clicked in the tab, show the tab panel
        tabButtons[i].addEventListener("click", function (e) {
          that.activateTab(tabButtons[i], tabButtons, tabWrapper);
        });

        // When tab is pressed
        if (tabOpener) {
          tabOpener.addEventListener("click", function (e) {
            e.preventDefault();
            that.scrollTop(tabWrapper.parentNode);
            tabWrapper.querySelector('.subscription-packages__tablist').classList.add("is-ready");
            tabWrapper.querySelector('.subscription-packages__tablist').classList.toggle("is-open");
          });
        }
      }
    }
  }

  /**
   * Activates the tab that is clicked and closes all other active tabs activated before
   *
   * @param {HTMLElement} currentTab tab that is pressed and should be activated
   * @param {HTMLElement} otherTabButtons Other tabs that should be closed
   * @param {HTMLElement} tabWrapper tha main wrapper for the tabs and tab panels
   */
  activateTab(currentTab, otherTabButtons, tabWrapper) {
    const that = this;
    const tab = currentTab;

    const tabPanelID = tab.getAttribute("aria-controls");

    if (tabPanelID) {
      const tabPanel = document.getElementById(tabPanelID);
      that.closeAllTabs(otherTabButtons, tab);

      if (tabPanel && tabPanel.style.display !== "block") {
        // Activates the current tab and shows the tab panel
        setTimeout(function () {
          currentTab.setAttribute("aria-selected", "true");
          currentTab.classList.add('is-active');
          slideDown(tabPanel, that.speed);
          tabPanel.focus();
          const closeButton = tabPanel.querySelector('.subscription-packages__close-button');

          closeButton.addEventListener("click", function () {
            that.closeAllTabs(otherTabButtons, false);
            that.scrollDown();

            // If all tabs are closed keep the first tab selected but not active
            if (window.innerWidth < 900 && otherTabButtons[0]) {
              otherTabButtons[0].setAttribute("aria-selected", "true");
            }
          });
        }, that.speed);
        that.scrollTop(tabWrapper.parentNode);
      } else {
        that.closeAllTabs(otherTabButtons, false);
        that.scrollDown();

        // If all tabs are closed keep the first tab selected but not active
        if (window.innerWidth < 900 && otherTabButtons[0]) {
          otherTabButtons[0].setAttribute("aria-selected", "true");
        }
      }
    }

    if (tabWrapper) {
      tabWrapper.querySelector('.subscription-packages__tablist').classList.remove("is-open");
    }
  }

  /**
   * Closes all tabs except the one that is clicked or false if all tabs should be closed
   *
   * @param {HTMLElement} tabButtons All tab buttons
   * @param {HTMLElement} activeTab active tab that should be kept open this can be added as false if all tabs are required to be closed
   */
  closeAllTabs(tabButtons, activeTab) {
    for (let i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i] !== activeTab) {
        const tab = tabButtons[i];
        tab.setAttribute("aria-selected", "false");
        tab.classList.remove('is-active');
        const tabPanelID = tab.getAttribute("aria-controls");

        if (tabPanelID) {
          const tabPanel = document.getElementById(tabPanelID);

          if (tabPanel.style.display === "block") {
            slideUp(tabPanel, 300);
            // tabPanel.style.display = "none";
          }
        }
      }
    }
  }

  /**
   * Scrolls to the top of the tab panel
   * @param {HTMLElement} tabWrapper the main tab wrapper required for calculating the scroll position
   */
  scrollTop(tabWrapper) {
    const that = this;
    const bodyRect = document.body.getBoundingClientRect();
    const header = document.querySelector('.site-header').getBoundingClientRect().height;
    const tabPanelsPosition = tabWrapper.getBoundingClientRect();
    let offset = tabPanelsPosition.top - bodyRect.top - header - 4;
    window.scroll({
      top: offset,
      left: 0,
      behavior: 'smooth'
    });
  }

  scrollDown() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}

new PackageTabs();
